import { render, staticRenderFns } from "./ViewEventRoles.vue?vue&type=template&id=2e748434"
import script from "./ViewEventRoles.vue?vue&type=script&lang=js"
export * from "./ViewEventRoles.vue?vue&type=script&lang=js"
import style0 from "./ViewEventRoles.vue?vue&type=style&index=0&id=2e748434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports